// app/features/blog/components/BlogShareComponent.tsx
'use client';

import { Check, Link2, Linkedin, Twitter } from 'lucide-react';
import { useState } from 'react';

interface BlogShareComponentProps {
  title: string;
  slug: string;
}

const iconButtonClass =
  'inline-flex items-center justify-center w-8 h-8 rounded-md text-text-tertiary hover:text-teal-dark hover:bg-beige-light transition-colors';

export default function BlogShareComponent({ title, slug }: BlogShareComponentProps) {
  const [copied, setCopied] = useState(false);
  const articleUrl = `https://howthef.ai/blog/${slug}`;
  const encodedTitle = encodeURIComponent(title);
  const encodedUrl = encodeURIComponent(articleUrl);

  function handleCopyLink() {
    navigator.clipboard.writeText(articleUrl);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  }

  return (
    <div>
      <p className="text-[11px] font-semibold text-text-tertiary uppercase tracking-[0.18em] mb-3">
        Share
      </p>
      <div className="flex items-center gap-1 -ml-1.5">
        <button
          type="button"
          onClick={() =>
            window.open(
              `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`,
              '_blank',
              'noopener,noreferrer',
            )
          }
          aria-label="Share on LinkedIn"
          className={iconButtonClass}
        >
          <Linkedin size={16} />
        </button>

        <button
          type="button"
          onClick={() =>
            window.open(
              `https://twitter.com/intent/tweet?text=${encodedTitle}&url=${encodedUrl}`,
              '_blank',
              'noopener,noreferrer',
            )
          }
          aria-label="Share on X"
          className={iconButtonClass}
        >
          <Twitter size={16} />
        </button>

        <button
          type="button"
          onClick={handleCopyLink}
          aria-label={copied ? 'Link copied' : 'Copy link'}
          className={iconButtonClass}
        >
          {copied ? (
            <Check size={16} className="text-success" />
          ) : (
            <Link2 size={16} />
          )}
        </button>

        {copied && (
          <span className="ml-1 text-[11px] text-success font-medium">Copied</span>
        )}
      </div>
    </div>
  );
}
